module.exports = __webpack_public_path__ + "img/opinion-post-thumb.3f27e481.jpg";